export default "__VITE_ASSET__34debab2__"